import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const changeDocDateRegistration = async ({ docId, registrationDate }) => {
  return await request.put(
    `/Docs/registration_date/${docId}?registrationDate=${registrationDate}`,
    null,
    'При изменении даты регистрации документа произошла ошибка',
    'Error'
  );
};

const useChangeDocDateRegistration = () => {
  const mutation = useMutation(changeDocDateRegistration, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

  return {
    isLoadingDocDateRegistration: mutation.isLoading,
    changeDocDateRegistration: mutation.mutateAsync,
  };
};

export default useChangeDocDateRegistration;
